export default {
  wallet: {
    title: 'Ví tiền',
    balance: 'Số dư',
    deposit: 'Nạp',
    withdraw: 'Rút tiền',
    rollover: 'Rollover',
    transaction: 'Giao dịch',
    myBet: 'Cược của tôi',
    totalBalance: 'Tổng số dư',
    withdrawableBalance: 'Số dư có thể rút',
    bonus: 'Tiền thưởng',
    bonusBalance: 'Số dư tiền thưởng',
    cashBalance: 'Số dư tiền mặt',
    withdrawable: 'Có thể rút',
    depositNow: 'Nạp ngay',
    getBonus: 'Nhận thưởng',
    bonusGames: 'Trò chơi thưởng',
    playNow: 'Chơi ngay',
    fiatAccount: 'Tài khoản tiền pháp định',
    cash: 'Tiền mặt',
    rules: 'Quy tắc',
    ruleQ1: '1. Tiền thưởng là gì?',
    ruleA1: 'Tiền thưởng là phần thưởng do nền tảng trao sau khi tham gia các hoạt động và có thể dùng để đặt cược trong các trò chơi thưởng được chỉ định.',
    ruleQ2: '2. Tôi có thể dùng tiền thưởng như thế nào?',
    ruleA2: 'Tiền thưởng chỉ có thể dùng để cược sau khi số dư ví tiền mặt đã hết. Tiền thưởng phải đạt yêu cầu vòng cược trước khi được chuyển sang ví tiền mặt.',
    ruleQ3: '3. Những trò chơi nào hỗ trợ cược bằng tiền thưởng?',
    ruleA3: 'Hầu hết các trò chơi slot đều hỗ trợ cược bằng tiền thưởng. Xem danh sách trò chơi chi tiết tại trang Trò chơi thưởng.',
    ruleQ4: '4. Có hạn chế nào khi chuyển tiền thưởng sang ví tiền mặt không?',
    ruleA4: 'Khi đạt yêu cầu vòng cược của tiền thưởng, bạn có thể chuyển tiền thưởng gốc sang ví tiền mặt tại Trung tâm Phần thưởng. Phần lợi nhuận thưởng còn lại sẽ được trả về Ví thưởng và yêu cầu vòng cược sẽ được tính lại.',
    ruleQ5: '5. Có hạn chế nào khi chuyển lợi nhuận thưởng sang ví tiền mặt không?',
    ruleA5: 'Lợi nhuận thưởng phải đạt yêu cầu vòng cược 15 lần. Lợi nhuận thưởng tối đa có thể chuyển sang ví tiền mặt là USDT5.000,00 và số tiền tối đa mỗi lần cược là USDT1.000,00.',
    ruleQ6: '6. Yêu cầu vòng cược được tính như thế nào?',
    ruleA6: 'Trò chơi slot: Số tiền cược = Yêu cầu vòng cược. Trò chơi khác: Số tiền cược = Giá trị tuyệt đối của lợi nhuận (tối đa bằng số tiền cược)',
    select: 'Chọn',
    currency: 'Tiền tệ',
    loading: 'Đang tải...',
    noMoreData: 'Không còn dữ liệu',
    noData: 'Không có dữ liệu',
    colType: 'Loại',
    colTime: 'Thời gian',
    colStatus: 'Trạng thái',
    colAmount: 'Số tiền',
    colBalance: 'Số dư',
    allType: 'Tất cả loại',
    allStats: 'Tất cả trạng thái',
    colWallet: 'Ví',
    colCurrent: 'Hiện tại',
    colRequired: 'Yêu cầu',
    colStats: 'Trạng thái',
    totalVaultBalance: 'Tổng số dư két',
    amount: 'Số tiền',
    availableBalance: 'Số dư khả dụng:',
    max: 'TỐI ĐA',
    depositInVault: 'Nạp vào két',
    depositCurrency: 'Tiền tệ nạp',
    currencyBalance: 'Số dư theo tiền tệ',
    history: 'Lịch sử',
    vaultRules: 'Quy tắc két',
    vaultRule1: 'Két là nơi an toàn để lưu trữ tiền mà không phải lo phí giao dịch hay chậm trễ của blockchain. Két hoạt động như ví kỹ thuật số của riêng bạn hoặc như tài khoản tiết kiệm ngân hàng. Cực kỳ an toàn nhờ 2FA và bạn có thể áp dụng các biện pháp bảo mật nâng cao để bảo vệ số tiền bên trong.',
    vaultRule2: 'Việc nạp và rút tiền trong Két được bảo vệ bằng 2FA và người gửi có thể truy cập bất cứ lúc nào.',
    vaultRule3: 'Tiền trong Két sẽ không bị ai chạm vào ngoại trừ người gửi. Đó là của bạn và luôn an toàn để bạn sử dụng!',
    selectTime: 'Chọn thời gian',
    colGame: 'Trò chơi',
    colBet: 'Cược',
    colWin: 'Thắng',
    colProfit: 'Lợi nhuận',
    sports: 'Thể thao',
    allGames: 'Tất cả trò chơi',
    today: 'Hôm nay',
    yesterday: 'Hôm qua',
    last3Days: '3 ngày qua',
    last7Days: '7 ngày qua',
    last15Days: '15 ngày qua',
    last30Days: '30 ngày qua',
  },
};
